import React from 'react';

import { VpHookFormInput, VpIcon } from '../..';
import { useFetchPluginById } from '../../../hooks';

export const VpPluginNameInput = ({ ...rest }) => {
  const { data } = useFetchPluginById();

  return (
    <VpHookFormInput
      isStandardInput
      endAdornment={<VpIcon icon="Edit3" />}
      disableUnderline
      placeholder="Plugin Name"
      boldValue
      disableHelperText
      includeDisplayInput
      required
      name="name"
      defaultValue={data?.name}
      {...rest}
    />
  );
};

export default VpPluginNameInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginNameInput.jsx